<div class="content-pane logout">
  <h2>Logged Out</h2>
  <h4>You have been logged out</h4>
  <p>To ensure that your session is completely closed, please quit your browser.</p>
  <button routerLink="/login" matButton="filled">Log In</button>
</div>
